var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("维护资产套装")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form", { ref: "suitInfo", attrs: { model: _vm.suit } }, [
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("基本信息")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("套装名称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "name",
                      rules: { validator: _vm.checkNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "262px" },
                      attrs: { type: "text", placeholder: "请输入套装名称" },
                      model: {
                        value: _vm.suit.name,
                        callback: function($$v) {
                          _vm.$set(_vm.suit, "name", $$v)
                        },
                        expression: "suit.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("所属机构")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "retailerShopName",
                      rules: { validator: _vm.checkNull, trigger: "blur" }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "bottom-line width-1-5x",
                      attrs: { placeholder: "请选择所属机构", disabled: true },
                      model: {
                        value: _vm.suit.retailerShopName,
                        callback: function($$v) {
                          _vm.$set(_vm.suit, "retailerShopName", $$v)
                        },
                        expression: "suit.retailerShopName"
                      }
                    }),
                    _vm._v(" "),
                    _vm.suit.id == null
                      ? _c("i", {
                          staticClass:
                            "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          attrs: { title: "选择" },
                          on: {
                            click: function($event) {
                              _vm.showOrgSelectDlg()
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("主资产信息")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-link",
              on: { click: _vm.showMainDeviceSelectDlg }
            },
            [_vm._v("选择主资产")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "simple-form" }, [
          _vm.suit.imageUrl != null && _vm.suit.imageUrl != ""
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("资产图片")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("img", {
                    staticStyle: { width: "100px" },
                    attrs: { src: _vm.suit.imageUrl }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产描述全称")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { placeholder: "请选择主资产", disabled: true },
                    model: {
                      value: _vm.suit.devcTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "devcTitle", $$v)
                      },
                      expression: "suit.devcTitle"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("系统编号")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { placeholder: "请选择主资产", disabled: true },
                    model: {
                      value: _vm.suit.devcTmpNo,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "devcTmpNo", $$v)
                      },
                      expression: "suit.devcTmpNo"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("分类")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { placeholder: "请选择主资产", disabled: true },
                    model: {
                      value: _vm.suit.devcCatName,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "devcCatName", $$v)
                      },
                      expression: "suit.devcCatName"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("品牌")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { placeholder: "请选择主资产", disabled: true },
                    model: {
                      value: _vm.suit.devcBrandName,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "devcBrandName", $$v)
                      },
                      expression: "suit.devcBrandName"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("规格")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { placeholder: "请选择主资产", disabled: true },
                    model: {
                      value: _vm.suit.devcModelSpec,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "devcModelSpec", $$v)
                      },
                      expression: "suit.devcModelSpec"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任部门")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.suit.departName,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "departName", $$v)
                      },
                      expression: "suit.departName"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任人")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c(
                "div",
                { staticClass: "pos-rel", staticStyle: { width: "262px" } },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.suit.principalName,
                      callback: function($$v) {
                        _vm.$set(_vm.suit, "principalName", $$v)
                      },
                      expression: "suit.principalName"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c("el-input", {
                  staticStyle: { height: "78px", width: "420px" },
                  attrs: { type: "textarea" },
                  model: {
                    value: _vm.suit.memo,
                    callback: function($$v) {
                      _vm.$set(_vm.suit, "memo", $$v)
                    },
                    expression: "suit.memo"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("附属资产信息")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-mini",
            on: { click: _vm.showOtherDeviceSelectDlg }
          },
          [_vm._v("选择附属资产")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.suit.shopDeviceSuitAccList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { align: "left", width: "100", label: "图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.imageUrl != null && rows.row.imageUrl != ""
                          ? _c("img", { attrs: { src: rows.row.imageUrl } })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "devcTitle",
                  label: "名称",
                  align: "left",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "devcTmpNo",
                  label: "系统编号",
                  width: "250",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "devcCatName",
                  label: "分类",
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "devcBrandName",
                  label: "品牌",
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "devcModelSpec",
                  label: "规格",
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "departName",
                  label: "责任部门",
                  width: "100",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "principalName",
                  label: "责任人",
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "memo", label: "备注" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入备注" },
                          model: {
                            value: rows.row.memo,
                            callback: function($$v) {
                              _vm.$set(rows.row, "memo", $$v)
                            },
                            expression: "rows.row.memo"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  label: "操作",
                  "show-overflow-tooltip": "",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeItem(scope.$index)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "swb-btn swb-btn-small", on: { click: _vm.saveSuit } },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b26ad8e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b26ad8e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceSuitSave.vue
// module id = 3155
// module chunks = 0